// @flow
import React, { Component } from "react";

type PropsType = {
  translate: string => void
};

type StateType = {};

class CounterUnit extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <section className="section text-white envanterium-counter-unit">
        <div className="container">
          <div className="row gap-y text-center">
            <div className="col-md-4">
              <p className="small text-uppercase ls-2">{translate("AboutPageLocale.counters.finished")}</p>
              <p className="lead-8 lh-1 fw-700">53</p>
            </div>

            <div className="col-md-4">
              <p className="small text-uppercase ls-2">{translate("AboutPageLocale.counters.customers")}</p>
              <p className="lead-8 lh-1 fw-700">16</p>
            </div>

            <div className="col-md-4">
              <p className="small text-uppercase ls-2">{translate("AboutPageLocale.counters.satisfaction")}</p>
              <p className="lead-8 lh-1 fw-700">100%</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CounterUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/AboutPage/CounterUnit.js